import { MixPanel } from '~/common';
import { APP_CONSTANTS, getCurrentUser } from '~/common/explicit-exports';
import { WRModals } from '~/components/wr-modals/wr-modals-container';
import { Go1CrossSellModal } from '~/features/cross-sells/components';

export const useGo1Modal = () => {
  const currentUser = getCurrentUser();
  const isAdmin = currentUser.admin;

  const hideGo1Modal = () => {
    MixPanel.track('go1_cross_sell_modal_closed', {
      isAdmin,
    });
  };
  const showGo1Modal = () => {
    const hasGo1Account = currentUser.enterprise.active_features.includes(APP_CONSTANTS.PRODUCT_FEATURES.GO1);

    MixPanel.track('go1_content_card_clicked', {
      isAdmin,
      showGo1Page: hasGo1Account,
    });

    // Redirect to Go1 Page if user's enterprise is onboarded with Go1 Add-on, else show cross-sell prompt
    if (hasGo1Account) {
      window.location.href = '/admin/prebuilt_content';
    } else {
      // TODO: Replace this with useDialog
      WRModals.custom(
        // @ts-expect-error: WRModals is not typed
        Go1CrossSellModal,
        {
          modalTitle: "Get content from the world's top providers",
          onSubmit: () => {
            MixPanel.track('go1_requested_cross_sell', {
              isAdmin,
            });
          },
        },
        null,
        hideGo1Modal,
      );
    }
  };

  return {
    showGo1Modal,
    hideGo1Modal,
  };
};
